// Browser requests must stay on the page origin, including HTTPS reverse proxies.
// The private upstream is configured server-side, never shipped as localhost JS.
export const apiBaseUrl = "";

export function csrfHeaders(): Record<string, string> {
  const cookie = document.cookie.split("; ").find((part) => part.startsWith("lernwerk_csrf="));
  return { "X-CSRF-Token": decodeURIComponent(cookie?.slice("lernwerk_csrf=".length) ?? "") };
}

export function accountError(status: number): string {
  if (status === 429) return "Zu viele Versuche. Bitte warte einige Minuten und versuche es erneut.";
  if (status === 401 || status === 403) return "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.";
  if (status === 422) return "Bitte prüfe deine Angaben. Das neue Passwort muss 12–128 Zeichen enthalten.";
  if (status === 503) return "Dieser Dienst ist gerade nicht erreichbar oder noch nicht eingerichtet. Bitte versuche es später erneut.";
  return "Der Vorgang konnte nicht abgeschlossen werden. Bitte versuche es erneut.";
}
